import InputSigarusSelect from '../InputSigarusSelect'
import inputExtend from './inputExtend'

import { getSelectInput, fetchURL } from '@/helpers/api'

/*
TEST HOOKS
const textprueba = inputExtend(InputSigarusText, [{
	hook: 'input',
	callback: function (comp, val) {
		return val + ' prueba test'
	}
}], {});
*/

const selectAsync = inputExtend(InputSigarusSelect, [], 
{
	props: {
		loading: {
			type: Boolean,
			default: false
		},
		remote: {
			type: Boolean,
			default: true
		},
		input: {
			type: Object
		},
		automaticDropdown: {
			default: true
		},
		multiple: {
			default: false
		}
	},
	methods: {
		async remoteMethod () {

			if (this.remote && this.list && this.list.length) return
			
			this.$parent.$parent.loading = true
			// this.$emit('update:loading', true)

			let resp = this.input.entidadUrl ? (await fetchURL(this.input.entidadUrl)).data : await getSelectInput(this.input.entidad)
			
			let data = resp.data
			
			this.$parent.$parent.loading = false
			// this.$emit('update:loading', false)

			this.list = data ? data.map(item => {
				return { value: item.value, label: item.text }
			}) : []
		},
		$render (val) {

			let value = val

			if (this.input.label) {

				value = this.input.label

			}  else if (this.list) {
				
				if (typeof val !== 'object') {
					value = this.list.find(f => f.value == val || f.label == val).label
				} else {
					
					// Si "val" es array lo recorremos y creamos el string de salida que se mostrara en el select
					return val.map(m => {
						return this.list.find(f => f.value == m).label
					}).join('<br>')
				}
			}

			return value
		}
	}
})

const selectList = inputExtend(InputSigarusSelect, [], 
{
	props: {
		options: {
			type: Array,
			default: () => []
		}
	},
	methods: {
		$render (val) {
			return this.options.length ? this.options.find(f => f.value == val).label : val
		}
	}
})

export default {
	//'list': InputSigarusSelect,
	'list': selectList,
	selectAsync
}
